// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__26kPf","search":"Settings_search__45tDY","filter":"Settings_filter__3oLPQ"};